export const extraChargeConstants = {
  GET_SINGLE_REQUEST: "EXTRA_CHARGE_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "EXTRA_CHARGE_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "EXTRA_CHARGE_GET_SINGLE_FAILURE",

  GET_ALL_REQUEST: "EXTRA_CHARGE_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "EXTRA_CHARGE_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "EXTRA_CHARGE_GET_ALL_FAILURE",

  ADD_REQUEST: "EXTRA_CHARGE_ADD_REQUEST",
  ADD_SUCCESS: "EXTRA_CHARGE_ADD_SUCCESS",
  ADD_FAILURE: "EXTRA_CHARGE_ADD_FAILURE",

  UPDATE_REQUEST: "EXTRA_CHARGE_UPDATE_REQUEST",
  UPDATE_SUCCESS: "EXTRA_CHARGE_UPDATE_SUCCESS",
  UPDATE_FAILURE: "EXTRA_CHARGE_UPDATE_FAILURE",

  DELETE_REQUEST: "EXTRA_CHARGE_DELETE_REQUEST",
  DELETE_SUCCESS: "EXTRA_CHARGE_DELETE_SUCCESS",
  DELETE_FAILURE: "EXTRA_CHARGE_DELETE_FAILURE",

  CLEAR: "EXTRA_CHARGE_CLEAR",
};
